import NavBar from "./NavBar";

export default function Attendance(){
    return (
        <>
            <NavBar />

        </>
    )
}